import React, { useContext, useState } from 'react'
import { useSelector } from 'react-redux'
import { State } from '../../redux/store'
import { ShowMoughataaContext, moughataaInterface } from './types'
import { FaEdit } from 'react-icons/fa'
import { MdRemoveCircle } from 'react-icons/md'
import { InputElement } from '../../HtmlComponents/InputElement'

const DataMoughataa = () => {
  const { moughataas } = useSelector((state: State) => state.moughataas)

  const { showDeleteModal, setShowDeleteModal, setSelectedMoughataa,
    showEditModal, setShowEditModal,
    
  } = useContext(ShowMoughataaContext)

  const toggleMoughataaModal = (moughataa: moughataaInterface) => {
    setShowEditModal(!showEditModal)
    setSelectedMoughataa(moughataa)
  }

  const toggleDeleteModal = (moughataa: moughataaInterface) => {
    setShowDeleteModal(!showDeleteModal)
    setSelectedMoughataa(moughataa)
  }
  
  const [search, setSearch] = useState("")

  return (
    <>
      <div className='mt-3 grid md:grid-cols-3'>
        <InputElement name='Chercher un moughataa' placeholder='Chercher un moughataa par son nom' value={search} setValue={setSearch} />
      </div>
    <div className='grid md:grid-cols-3'>
    <div className="col-span-2 flex flex-col border">
        <div className="overflow-x-auto"> {/* sm:-mx-6 lg:-mx-8 */}
          <div className="inline-block min-w-full sm:px-6 lg:px-8">
            <div className="overflow-hidden">
              <table className="min-w-full text-left text-sm font-light">
                <thead className="border-b font-medium bg-main text-white">
                  <tr>
                    <th className="px-4 py-4 border-r">Nom</th>
                    <th className="px-4 py-4 border-r">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {moughataas
                    .filter((moughataa: moughataaInterface) => moughataa.name.includes(search))
                    .map((moughataa: moughataaInterface, index) => (
                    <tr className="border-b" key={index}>
                      <td className="whitespace-nowrap px-4 py-2 border-r bg-white font-medium">
                        {moughataa.name}
                      </td>                        
                      <td className="whitespace-nowrap px-4 py-2 border-r bg-white font-medium">
                        <div className='flex justify-center items-center'>
                          <FaEdit className='text-second text-2xl' onClick={() => toggleMoughataaModal(moughataa)} />
                          <MdRemoveCircle className='text-red text-2xl' onClick={() => toggleDeleteModal(moughataa)} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    </>
  )
}

export default DataMoughataa